import type { TranslationKey } from '../keys';

const ar: Record<TranslationKey, string> = {
  'app.loading': 'جاري تحميل لوحة التحكم...',
  'app.title': 'غراميات',
  'brand.name': 'غراميات',
  'brand.mascot.her': 'رسمة لها: سيدة كرتونية واضعة يدها على خصرها',
  'brand.mascot.him': 'رسمة له: رجل كرتوني يستعرض عضلاته بابتسامة شقية',
  'brand.mascot.pair': 'رسمة للثنائي: سيدة ورجل كرتونيان وجهًا لوجه بينهما قلب',

  'nav.home': 'الرئيسية',
  'nav.dashboard': 'لوحة التحكم',
  'nav.game': 'اللعب',
  'nav.settings': 'الإعدادات',
  'nav.history': 'السجل',
  'nav.rewards': 'المكافآت',
  'nav.fantasy': 'الخيال',
  'nav.admin': 'المسؤول',
  'nav.logout': 'تسجيل الخروج',
  'nav.backToDashboard': 'العودة إلى لوحة التحكم',
  'nav.welcomeUser': 'مرحباً، {{name}}!',

  'common.back': 'رجوع',
  'common.continue': 'متابعة',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ التغييرات',
  'common.saving': 'جاري الحفظ...',
  'common.saveSuccess': 'تم حفظ الإعدادات بنجاح!',
  'common.saveError': 'فشل حفظ الإعدادات. حاول مرة أخرى.',
  'common.optional': '(اختياري)',
  'common.all': 'الكل',
  'common.you': 'أنت',
  'common.partner': 'الشريك',
  'common.random': 'عشوائي',
  'common.custom': 'مخصص',
  'common.retry': 'إعادة المحاولة',
  'common.exit': 'خروج',
  'common.cards':
    'لا بطاقات|بطاقة واحدة|بطاقتان|{{count}} بطاقات|{{count}} بطاقة|{{count}} بطاقة',
  'common.level': 'المستوى {{level}}',

  'settings.title': 'الإعدادات',
  'settings.subtitle': 'خصّص تجربتك وأدر حسابك',
  'settings.profile': 'الملف الشخصي',
  'settings.gameSettings': 'إعدادات اللعبة',
  'settings.profileTitle': 'معلومات الملف الشخصي',
  'settings.profileSubtitle': 'تفاصيل حسابك وتفضيلاتك',
  'settings.name': 'الاسم',
  'settings.email': 'البريد الإلكتروني',
  'settings.role': 'الدور',
  'settings.notAvailable': 'غير متوفر',
  'settings.language': 'اللغة',
  'settings.difficulty': 'مستوى الصعوبة',
  'settings.contentPreferences': 'تفضيلات المحتوى',
  'settings.showExplicit': 'إظهار المحتوى الصريح',
  'settings.egyptianSlang': 'بطاقات العامية المصرية',
  'settings.egyptianSlangDesc':
    'بطاقات جريئة مكتوبة بالعامية المصرية. لو قفلتها مش هتظهر في أي لعبة.',
  'settings.notifications': 'تفعيل الإشعارات',
  'settings.sound': 'تفعيل المؤثرات الصوتية',
  'settings.showPromptImages': 'إظهار صور البطاقات والأوضاع',
  'settings.showPromptImagesDesc':
    'عند الإيقاف يظل نص التحدي يظهر لكن تُخفى الصور التوضيحية.',

  'gameSettings.title': 'إعدادات اللعبة',
  'gameSettings.subtitle': 'خصّص تجربة اللعب وتفضيلاتك',
  'gameSettings.general': 'عام',
  'gameSettings.gameplay': 'طريقة اللعب',
  'gameSettings.appearance': 'المظهر',
  'gameSettings.notifications': 'الإشعارات',
  'gameSettings.generalTitle': 'الإعدادات العامة',
  'gameSettings.generalSubtitle': 'الإعدادات الأساسية لحسابك',
  'gameSettings.autoSave': 'حفظ التقدم تلقائياً',
  'gameSettings.autoSaveDesc': 'حفظ تقدم اللعبة والإعدادات تلقائياً',
  'gameSettings.gameplayTitle': 'إعدادات اللعب',
  'gameSettings.gameplaySubtitle': 'خصّص تجربة اللعب',
  'gameSettings.appearanceTitle': 'إعدادات المظهر',
  'gameSettings.appearanceSubtitle': 'خصّص مظهر اللعبة',
  'gameSettings.notificationsTitle': 'الإشعارات والصوت',
  'gameSettings.notificationsSubtitle': 'إدارة تفضيلات الإشعارات',
  'gameSettings.saveSectionTitle': 'حفظ التغييرات',
  'gameSettings.saveSectionDesc': 'سيتم تطبيق إعداداتك فوراً',

  'difficulty.easy.label': 'سهل',
  'difficulty.easy.desc': 'تحديات بسيطة للمبتدئين',
  'difficulty.medium.label': 'متوسط',
  'difficulty.medium.desc': 'تحديات متوازنة لمعظم الأزواج',
  'difficulty.hard.label': 'صعب',
  'difficulty.hard.desc': 'تحديات متقدمة للأزواج ذوي الخبرة',

  'setup.step.players': 'اللاعبون',
  'setup.step.category': 'الفئة',
  'setup.step.spice': 'الحرارة',
  'setup.stepOf': 'الخطوة {{current}} من {{total}}',
  'setup.backToDashboard': 'العودة إلى لوحة التحكم',
  'setup.exitSetup': 'الخروج من إعداد اللعبة',
  'setup.coupleTitle': 'إعداد الزوجين',
  'setup.coupleSubtitle':
    'اختر ديناميكية الزوجين والأسماء — التحديات تتناسب مع دور كل شخص.',
  'setup.coupleDynamic': 'ديناميكية الزوجين',
  'setup.sameDevice': 'جهاز واحد',
  'setup.player1Label': 'اللاعب 1 · أنت · {{gender}}',
  'setup.player2Label': 'اللاعب 2 · الشريك · {{gender}}',
  'setup.yourName': 'اسمك',
  'setup.partnerName': 'اسم الشريك',
  'setup.twoPhones.hint':
    'تريدان اللعب على هاتفين؟ في الإعداد السريع خيار «عن بُعد» وخيار «هاتفان في الغرفة نفسها».',
  'setup.twoPhones.quick': 'افتح الإعداد السريع',
  'setup.twoPhones.partner': 'اذهب إلى الشريك',
  'setup.pickVibe': 'اختر الأجواء',
  'setup.pickVibeSubtitle': 'اختياري — اضغط «فاجئني» للمزج العشوائي.',
  'setup.surpriseMe': 'فاجئني',
  'setup.narrowDown': 'ضيّق الاختيار',
  'setup.narrowDownHint':
    'اضغط فئة فرعية لتركيز البطاقات، أو اترك «الكل» للمزج الكامل.',
  'setup.loadingSubcategories': 'جاري تحميل الفئات الفرعية…',
  'setup.fantasyExplorerTruthHint':
    'لمعالج كتالوج الخيالات (مثل تكوينات الثلاثي)، اختر «استكشاف الخيالات» من الفئات الفرعية وليس «صراحة» وحدها.',
  'setup.fantasyExplorerLeafHint':
    'يفتح معالج استكشاف الخيالات: تصفّح موضوعات الكتالوج حسب القسم، اختر أفضل 3، ثم ضيّق (مثل أنواع الثلاثي).',
  'setup.availabilityNoCards': 'لا توجد بطاقات',
  'setup.availabilityLimited':
    'محدود · لا بطاقات|محدود · بطاقة واحدة|محدود · بطاقتان|محدود · {{count}} بطاقات|محدود · {{count}} بطاقة|محدود · {{count}} بطاقة',
  'setup.howHot': 'ما مدى الحرارة الليلة؟',
  'setup.spiceSubtitle':
    'يمكن اختيار المستويات التي تحتوي بطاقات في الفئة المختارة فقط.',
  'setup.noCardsWarning':
    'لا توجد بطاقات مطابقة لهذه الفئة مع إعداد اللاعبين الحالي. اختر فئة أخرى أو عدّل ديناميكية الزوجين في الخطوة 1.',
  'setup.readyToPlay': 'جاهز للعب',
  'setup.summaryPlayStyle': 'أسلوب اللعب',
  'setup.summaryPlayers': 'اللاعبون',
  'setup.summaryCategory': 'الفئة',
  'setup.summarySpice': 'الحرارة',
  'setup.starting': 'جاري البدء…',
  'setup.startGame': 'بدء اللعبة',

  'couple.maleFemale.label': 'رجل وامرأة',
  'couple.maleFemale.desc': 'أنت تلعب كرجل والشريك كامرأة',
  'couple.femaleMale.label': 'امرأة ورجل',
  'couple.femaleMale.desc': 'أنت تلعب كامرأة والشريك كرجل',
  'couple.femaleFemale.label': 'امرأة وامرأة',
  'couple.femaleFemale.desc': 'تحديات مشتركة حتى إطلاق مجموعة مخصصة',
  'couple.gender.man': 'رجل',
  'couple.gender.woman': 'امرأة',

  'spice.mild.label': 'خفيف',
  'spice.mild.tagline': 'غزل لطيف وممازحة هادئة',
  'spice.warm.label': 'دافئ',
  'spice.warm.tagline': 'كيمياء مريحة تتصاعد',
  'spice.hot.label': 'ساخن',
  'spice.hot.tagline': 'توتر مرح يتصاعد',
  'spice.spicy.label': 'حار',
  'spice.spicy.tagline': 'تحديات جريئة وخجول',
  'spice.explicit.label': 'صريح',
  'spice.explicit.tagline': 'بلا قيود، كل الشرارة',
  'spice.intense.label': 'مكثف',
  'spice.intense.tagline': 'لحظات تسرع القلب',
  'spice.wild.label': 'جامح',
  'spice.wild.tagline': 'مغامر ومن دون قيود',
  'spice.fierce.label': 'قوي',
  'spice.fierce.tagline': 'شغف بأعلى صوت',
  'spice.extreme.label': 'متطرف',
  'spice.extreme.tagline': 'للشجعان معاً',
  'spice.maximum.label': 'أقصى',
  'spice.maximum.tagline': 'استكشاف كل الحدود',
  'spice.preset.sweet': 'حلو وببطء',
  'spice.preset.steamy': 'ليلة بخار',
  'spice.preset.wildRide': 'رحلة جامحة',
  'spice.preset.range': '{{min}}–{{max}}',
  'spice.heat.soft': 'خفيف',
  'spice.heat.scorching': 'حار جداً',
  'spice.unavailable': 'غير متاح',
  'spice.loadingAvailability':
    'جاري التحقق من مستويات الحرارة المتاحة لهذه الفئة…',
  'spice.levelRange': 'المستويات {{min}}–{{max}}',
  'spice.cardsAtLevel':
    'لا بطاقات في هذا المستوى|بطاقة واحدة في هذا المستوى|بطاقتان في هذا المستوى|{{count}} بطاقات في هذا المستوى|{{count}} بطاقة في هذا المستوى|{{count}} بطاقة في هذا المستوى',
  'spice.cardsInRange':
    'لا بطاقات عبر المستويات {{min}}–{{max}}|بطاقة واحدة عبر المستويات {{min}}–{{max}}|بطاقتان عبر المستويات {{min}}–{{max}}|{{count}} بطاقات عبر المستويات {{min}}–{{max}}|{{count}} بطاقة عبر المستويات {{min}}–{{max}}|{{count}} بطاقة عبر المستويات {{min}}–{{max}}',
  'spice.cardsInCategory':
    'لا بطاقات في هذه الفئة|بطاقة واحدة في هذه الفئة|بطاقتان في هذه الفئة|{{count}} بطاقات في هذه الفئة|{{count}} بطاقة في هذه الفئة|{{count}} بطاقة في هذه الفئة',
  'spice.perLevel': '{{count}} لكل مستوى',
  'spice.surpriseTitle': 'فاجئنا',
  'spice.surpriseDesc': 'اختر مستوى الحرارة أدناه، أو تخطَّ للمزج العشوائي',
  'spice.pickerLabel': 'مستوى الحرارة',

  'game.scoreboard': 'لوحة النقاط',
  'game.round': 'الجولة {{round}}',
  'game.yourTurn': 'دورك',
  'game.playerTurn': 'دور {{name}}',
  'game.player1Turn': 'دور اللاعب 1',
  'game.player2Turn': 'دور اللاعب 2',
  'game.endGame': 'إنهاء اللعبة',
  'game.quickExit': 'خروج سريع',
  'game.fantasyExplorer': 'استكشاف الخيالات',
  'fantasyExplorer.selectedCount': 'تم اختيار {{selected}} / {{total}}',
  'game.noMorePrompts': 'لا توجد تحديات أخرى',
  'game.somethingWrong': 'حدث خطأ ما',
  'game.deckRepeat': 'شاهدت كل بطاقة في هذه المجموعة — إليك تكراراً.',
  'game.spiceMismatch':
    'مزاج الجلسة هو المستوى {{sessionLevel}}، لكن هذه البطاقة مستوى {{cardLevel}}{{suffix}}.',
  'game.spiceMismatchSuffix': ' (أقرب تطابق متاح)',
  'game.undoFailed': 'تعذّر التراجع. حاول مرة أخرى.',
  'game.undoNothing': 'لا يوجد ما يمكن التراجع عنه.',
  'game.finalResults': 'النتائج النهائية',
  'game.skip': 'تخطي',
  'game.complete': 'إكمال',
  'game.saving': 'جاري الحفظ…',
  'game.savedNext': 'تم الحفظ — جاري تحميل التحدي التالي…',
  'game.answer.group': 'كروت الإجابة',
  'game.answer.outLoud': 'هجاوب بصوتي',
  'game.answer.chose': 'اختيار {{name}}',
  'game.answer.choosing': 'مستنيين اختيار {{name}}...',
  'game.answer.error.invalid': 'الإجابة دي مش على الكارت ده. حدّثنا اللعبة.',

  'history.title': 'سجل الألعاب',
  'history.subtitle': 'تابع تقدمك واطّلع على التحديات المكتملة',
  'history.totalGames': 'إجمالي الألعاب',
  'history.completedGames': 'ألعاب مكتملة',
  'history.completedCards': 'بطاقات مكتملة',
  'history.totalCards': 'إجمالي البطاقات',
  'history.cardsPlayed': 'بطاقات لُعبت',
  'history.avgScore': 'متوسط النقاط',
  'history.avgTime': 'متوسط الوقت',
  'history.searchPlaceholder': 'ابحث في التحديات...',
  'history.filters': 'تصفية',
  'history.sortBy': 'ترتيب حسب:',
  'history.sort.date': 'التاريخ',
  'history.sort.score': 'النقاط',
  'history.sort.time': 'الوقت',
  'history.filter.category': 'الفئة',
  'history.filter.allCategories': 'كل الفئات',
  'history.filter.spiceLevel': 'مستوى الحرارة',
  'history.filter.allLevels': 'كل المستويات',
  'history.spiceHearts': '{{level}} قلوب',
  'history.loading': 'جاري تحميل سجل الألعاب...',
  'history.emptyTitle': 'لا توجد ألعاب',
  'history.emptyFiltered': 'جرّب تعديل التصفية أو كلمات البحث.',
  'history.emptyDefault': 'ابدأ اللعب لبناء سجل ألعابك!',
  'history.startFirstGame': 'ابدأ أول لعبة',
  'history.challengeCompleted': 'تم إكمال التحدي',
  'history.score': 'النقاط',
  'history.time': 'الوقت',
  'history.progress': 'التقدم',
  'history.progressPercent': '{{percent}}٪',

  'rewards.title': 'المكافآت',
  'rewards.subtitle': 'سلاسلك وإحصائياتك وإنجازاتك',
  'rewards.loading': 'جارٍ تحميل مكافآتك...',
  'rewards.dayStreak': 'أيام متتالية',
  'rewards.streakProgress': '{{count}} من {{goal}} أيام',
  'rewards.cardsPlayed': 'بطاقات لُعبت',
  'rewards.cardsCompleted': 'بطاقات مكتملة',
  'rewards.totalScore': 'مجموع النقاط',
  'rewards.achievements': 'الإنجازات',
  'rewards.day.mon': 'ن',
  'rewards.day.tue': 'ث',
  'rewards.day.wed': 'ر',
  'rewards.day.thu': 'خ',
  'rewards.day.fri': 'ج',
  'rewards.day.sat': 'س',
  'rewards.day.sun': 'ح',
  'rewards.badge.streak7.title': 'سلسلة ٧ أيام',
  'rewards.badge.streak7.desc': 'العبا ٧ أيام متتالية',
  'rewards.badge.truthSeeker.title': 'باحث الحقيقة',
  'rewards.badge.truthSeeker.desc': 'أكملا ٢٠ سؤال صراحة',
  'rewards.badge.dareDevil.title': 'جريء التحدي',
  'rewards.badge.dareDevil.desc': 'أكملا ١٠ تحديات',
  'rewards.badge.fantasist.title': 'صانع الخيال',
  'rewards.badge.fantasist.desc': 'أكملا ١٥ بطاقة خيال',
  'rewards.badge.spiceMaster.title': 'سيد الإثارة',
  'rewards.badge.spiceMaster.desc': 'العبا بمستوى ٩+ خمس مرات',
  'rewards.badge.soulmates.title': 'توأما روح',
  'rewards.badge.soulmates.desc': 'العبا معًا في ٣٠ يومًا',
  'rewards.badge.luckyScratch.title': 'حظ الخدش',
  'rewards.badge.luckyScratch.desc': 'اكشفا ٥ بطاقات خدش',
  'rewards.badge.legend.title': 'أسطورة',
  'rewards.badge.legend.desc': 'اصلا إلى ١٠٠ بطاقة',

  'onboarding.welcomeTo': 'مرحبًا بكما في',
  'onboarding.welcomeBody':
    'صراحة وتحدي وخيال والمزيد — صُمم لكما أنتما الاثنين.',
  'onboarding.continue': 'متابعة',
  'onboarding.startPlaying': 'ابدآ اللعب',
  'onboarding.skip': 'تخطٍ',
  'dashboard.greeting.morning': 'صباح الخير',
  'dashboard.greeting.afternoon': 'طاب يومك',
  'dashboard.greeting.evening': 'مساء الخير',
  'dashboard.greeting.night': 'أهلاً',
  'dashboard.greeting.withName': '{{greeting}}، {{name}}',
  'dashboard.streak.days':
    'سلسلة {{count}} يوم|سلسلة يوم واحد|سلسلة يومين|سلسلة {{count}} أيام|سلسلة {{count}} يومًا|سلسلة {{count}} يوم',
  'dashboard.streak.none': 'ابدأ سلسلة جديدة',
  'dashboard.partner.playingWith': 'مع {{name}}',
  'dashboard.partner.add': 'أضف شريكك',
  'dashboard.resume.label': 'لعبة قيد التقدم',
  'dashboard.resume.paused': 'متوقفة مؤقتاً',
  'dashboard.resume.round': 'الجولة {{round}}',
  'dashboard.resume.button': 'استئناف',
  'dashboard.playAgain.label': 'آخر لعبة',
  'dashboard.playAgain.button': 'العب مرة أخرى',
  'dashboard.starting': 'جارٍ البدء…',
  'dashboard.error.start': 'تعذّر بدء اللعبة. حاول مرة أخرى.',
  'dashboard.customGame': 'لعبة مخصصة',
  'dashboard.error.partnerSession':
    'شريكك بدأ لعبة بالفعل. انضم إليها بدلًا من ذلك.',
  'dashboard.joinInstead':
    'انضم إلى لعبة {{name}}، أو أنهِها من داخل اللعبة لتبدأ لعبة جديدة.',
  'dashboard.mixTitle': 'مزيج عشوائي',
  'dashboard.moods.title': 'اختر أجواء الليلة',
  'dashboard.moods.subtitle': 'نقرة واحدة وتبدآن اللعب',
  'mood.reason.explicit': 'فعّل البطاقات الصريحة من الإعدادات للعب هذه الأجواء',
  'mood.reason.empty': 'لا توجد بطاقات تناسب هذه الأجواء حالياً',
  'mood.reason.remote': 'اربط حسابك بشريكك للعب هذه الأجواء',
  'mood.reason.fewExplicit':
    'عدد البطاقات غير كافٍ. فعّل البطاقات الصريحة أو غيّر إعداداتك',
  'mood.reason.few': 'عدد البطاقات غير كافٍ لإعداداتك',
  'mood.error.notPlayable':
    'لا تتوفر بطاقات كافية لهذه الأجواء وفق إعداداتك. فعّل البطاقات الصريحة أو غيّر إعداداتك ثم حاول مجددًا.',
  'quickSetup.title': 'إعداد سريع',
  'quickSetup.subtitle': 'كل شيء جاهز مسبقاً. غيّرا ما تريدان ثم ابدآ.',
  'quickSetup.players': 'اللاعبان',
  'quickSetup.dynamic.aria': 'ديناميكية الثنائي: {{label}}. اضغط للتغيير',
  'quickSetup.where': 'أين أنتما؟',
  'quickSetup.together': 'معاً',
  'quickSetup.apart': 'عن بُعد',
  'quickSetup.mood.heading': 'ما أجواء الليلة؟',
  'quickSetup.categories.show': 'اختر الفئات بدلاً من ذلك',
  'quickSetup.categories.hide': 'العودة إلى الأجواء',
  'quickSetup.categories.heading': 'الفئات',
  'quickSetup.heat': 'ما درجة الإثارة؟',
  'quickSetup.explicitHint':
    'المستويات من 7 إلى 10 صريحة. فعّل البطاقات الصريحة من الإعدادات عشان تلعبها.',
  'quickSetup.explicitHint.link': 'الإعدادات',
  'quickSetup.count':
    'لا توجد بطاقة مناسبة|بطاقة واحدة مناسبة|بطاقتان مناسبتان|{{count}} بطاقات مناسبة|{{count}} بطاقة مناسبة|{{count}} بطاقة مناسبة',
  'quickSetup.count.loading': 'جارٍ عدّ البطاقات…',
  'quickSetup.count.mixed': 'مزيج من كل الفئات',
  'quickSetup.count.custom': 'جاهزان للعب',
  'quickSetup.reason.partner': 'أضف اسم شريكك للبدء',
  'quickSetup.reason.noCards':
    'لا توجد بطاقات بهذا المستوى. جرّب مستوى أو فئة أخرى.',
  'quickSetup.custom': 'تريدان تحكماً أكثر؟ لعبة مخصصة',
  'setup.dynamic.maleMale.label': 'رجل ورجل',
  'setup.dynamic.maleMale.desc': 'تحديات مشتركة حتى إطلاق مجموعة مخصصة',
  'onboarding.progress': 'الخطوة {{current}} من {{total}}',
  'onboarding.names.title': 'من سيلعب؟',
  'onboarding.names.body':
    'الأسماء اختيارية، لكنها تجعل كل بطاقة تبدو مكتوبة لكما.',
  'onboarding.names.you': 'اسمك',
  'onboarding.names.partner': 'اسم شريكك',
  'onboarding.names.suggestions': 'أسماء الشركاء المحفوظة',
  'onboarding.gender.title': 'أنا',
  'onboarding.gender.woman': 'امرأة',
  'onboarding.gender.man': 'رجل',
  'onboarding.gender.womanLower': 'امرأة',
  'onboarding.gender.manLower': 'رجل',
  'onboarding.gender.locked':
    'دورك في اللعب: {{gender}}. تم اختيار هذا مرة واحدة ولا يمكن تغييره.',
  'onboarding.partnerGender.title': 'شريكك هو',
  'onboarding.partnerGender.body':
    'لتناسب البطاقات كليكما. ويمكنكما تركه لوقت لاحق.',
  'onboarding.partnerGender.woman': 'امرأة',
  'onboarding.partnerGender.man': 'رجل',
  'onboarding.comfort.title': 'ما درجة الإثارة التي تريحكما؟',
  'onboarding.comfort.body':
    'هذه نقطة البداية فقط، ويمكنكما تغييرها في كل لعبة.',
  'onboarding.boundaries.title': 'أخفيا هذه الفئات من ألعابنا',
  'onboarding.boundaries.body':
    'اضغطا على ما تفضّلان ألا يظهر. يمكنكما التغيير لاحقاً.',
  'onboarding.boundaries.empty':
    'تعذّر تحميل الفئات. يمكنكما ضبط الحدود لاحقاً.',
  'onboarding.boundaries.keepOne':
    'أبقيا فئة واحدة على الأقل، وإلا فلن يتبقى ما تلعبانه.',
  'onboarding.boundaries.explicit': 'إظهار البطاقات الصريحة',
  'onboarding.boundaries.explicitHint':
    'عند الإيقاف تُستبعد أكثر البطاقات جرأة.',
  'onboarding.finish': 'إنهاء',
  'onboarding.saveError':
    'تعذّر حفظ اختياراتكما. تحققا من الاتصال وحاولا مرة أخرى أو تخطّيا.',
  'history.customGame': 'لعبة مخصصة',
  'history.view.label': 'طريقة عرض السجل',
  'history.view.games': 'حسب اللعبة',
  'history.view.cards': 'كل البطاقات',
  'history.status.completed': 'مكتملة',
  'history.status.paused': 'متوقفة',
  'history.status.active': 'جارية',
  'history.sessions.failed': 'تعذّر تحميل ألعابك.',
  'history.session.rounds': 'الجولات: {{count}}',
  'history.rounds.loading': 'جارٍ تحميل الجولات…',
  'history.rounds.failed': 'تعذّر تحميل الجولات.',
  'history.rounds.empty': 'لم تُلعب أي بطاقة في هذه اللعبة.',
  'history.round.number': 'البطاقة {{number}}',
  'history.round.skipped': 'تم التخطي',
  'history.loadMore': 'عرض المزيد',

  'settings.replayIntro': 'إعادة المقدمة',

  'common.close': 'إغلاق',

  'common.loading': 'جارٍ التحميل...',
  'auth.field.email': 'البريد الإلكتروني',
  'auth.field.password': 'كلمة المرور',
  'auth.placeholder.email': 'أدخل بريدك الإلكتروني',
  'auth.placeholder.password': 'أدخل كلمة المرور',
  'auth.password.show': 'إظهار كلمة المرور',
  'auth.password.hide': 'إخفاء كلمة المرور',
  'auth.backToLogin': 'العودة إلى تسجيل الدخول',
  'auth.login.title': 'أهلاً بعودتك',
  'auth.login.subtitle': 'سجّل الدخول لتواصل مغامرتك',
  'auth.login.submit': 'تسجيل الدخول',
  'auth.login.submit.loading': 'جارٍ تسجيل الدخول...',
  'auth.login.noAccount': 'ليس لديك حساب؟',
  'auth.login.createAccount': 'إنشاء حساب',
  'auth.login.forgot': 'هل نسيت كلمة المرور؟',
  'auth.forgot.title': 'هل نسيت كلمة المرور؟',
  'auth.forgot.subtitle':
    'لا تقلق! أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.',
  'auth.forgot.placeholder': 'أدخل عنوان بريدك الإلكتروني',
  'auth.error.rateLimited': 'محاولات كثيرة. انتظر دقيقة ثم حاول مرة أخرى.',
  'auth.error.invalidCredentials':
    'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  'auth.error.network': 'لا يوجد اتصال. تحقق من الشبكة وحاول مرة أخرى.',
  'auth.error.generic': 'حدث خطأ ما. حاول مرة أخرى.',
  'auth.forgot.submit': 'إرسال رابط إعادة التعيين',
  'auth.forgot.submit.loading': 'جارٍ إرسال الرابط...',
  'auth.forgot.sent.title': 'تحقق من بريدك الإلكتروني',
  'auth.forgot.sent.body':
    'إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني، فقد أرسلنا إليه رابط إعادة التعيين. اضغط على الرابط في الرسالة لإعادة تعيين كلمة المرور.',
  'auth.forgot.sent.noEmail': 'لم تصلك الرسالة؟',
  'auth.forgot.sent.noEmailHint':
    'تحقق من مجلد البريد غير الهام أو انتظر بضع دقائق ثم حاول مجدداً.',
  'auth.forgot.sent.again': 'إرسال رسالة أخرى',
  'auth.validation.emailRequired': 'البريد الإلكتروني مطلوب',
  'auth.validation.emailInvalid': 'يرجى إدخال عنوان بريد إلكتروني صالح',

  'auth.field.fullName': 'الاسم الكامل',
  'auth.field.confirmPassword': 'تأكيد كلمة المرور',
  'auth.field.dateOfBirth': 'تاريخ الميلاد',
  'auth.placeholder.fullName': 'أدخل اسمك الكامل',
  'auth.placeholder.createPassword': 'أنشئ كلمة مرور',
  'auth.placeholder.confirmPassword': 'أكّد كلمة المرور',
  'auth.register.title': 'انضم إلى المغامرة',
  'auth.register.subtitle': 'أنشئ حسابك للبدء',
  'auth.register.gender.title': 'أنا',
  'auth.register.gender.woman': 'امرأة',
  'auth.register.gender.man': 'رجل',
  'auth.register.gender.hint':
    'ده بيحدد اختيارات الثنائي اللي هتظهرلك، ومش هينفع تتغير بعد كده.',
  'auth.register.ageHint': 'يجب أن يكون عمرك 18 عاماً أو أكثر للانضمام.',
  'auth.register.consent.prefix': 'أؤكد أن عمري 18 عاماً أو أكثر وأوافق على',
  'auth.register.consent.link': 'شروط الاستخدام',
  'auth.register.consent.suffix':
    '. يحتوي هذا التطبيق على محتوى صريح للبالغين.',
  'auth.register.submit': 'إنشاء حساب',
  'auth.register.submit.loading': 'جارٍ إنشاء الحساب...',
  'auth.register.haveAccount': 'لديك حساب بالفعل؟',
  'auth.register.signIn': 'تسجيل الدخول',

  'auth.field.newPassword': 'كلمة المرور الجديدة',
  'auth.field.confirmNewPassword': 'تأكيد كلمة المرور الجديدة',
  'auth.placeholder.newPassword': 'أدخل كلمة المرور الجديدة',
  'auth.placeholder.confirmNewPassword': 'أكّد كلمة المرور الجديدة',
  'auth.validation.passwordRequired': 'كلمة المرور مطلوبة',
  'auth.validation.passwordMin': 'يجب ألا تقل كلمة المرور عن {{min}} أحرف',
  'auth.validation.confirmRequired': 'تأكيد كلمة المرور مطلوب',
  'auth.validation.mismatch': 'كلمتا المرور غير متطابقتين',
  'auth.reset.title': 'إعادة تعيين كلمة المرور',
  'auth.reset.subtitle':
    'أدخل كلمة المرور الجديدة أدناه لإكمال عملية إعادة التعيين.',
  'auth.reset.submit': 'إعادة تعيين كلمة المرور',
  'auth.reset.submit.loading': 'جارٍ إعادة تعيين كلمة المرور...',
  'auth.reset.success.title': 'تمت إعادة تعيين كلمة المرور بنجاح!',
  'auth.reset.success.body':
    'تمت إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
  'auth.reset.success.goToLogin': 'الانتقال إلى تسجيل الدخول',

  'landing.signIn': 'تسجيل الدخول',
  'landing.getStarted': 'العب ببلاش',
  'landing.badge': 'لعبة مغامرات جديدة للأزواج',
  'landing.hero.line1': 'اكتشف',
  'landing.hero.line2': 'مغامرة حبّكما',
  'landing.hero.subtitle':
    'عيشا متعة تحديات بطاقات الخدش المصممة خصيصاً للأزواج. اكشفا عن أفكار مشوقة، وأنجزا مهام ممتعة، وقوّيا رابطكما معاً في مغامرة رومانسية آسرة.',
  'landing.cta.start': 'العب دلوقتي، ببلاش',
  'landing.cta.haveAccount': 'لديك حساب بالفعل؟ سجّل الدخول',
  'landing.features.title': 'لماذا يحب الأزواج هذه اللعبة',
  'landing.features.subtitle':
    'صُممت لتقريب الأزواج من بعضهم عبر تحديات ممتعة وتفاعلية وتجارب غامرة',
  'landing.feature.bonds.title': 'عزّزا الروابط',
  'landing.feature.bonds.body':
    'أنجزا التحديات معاً واكتشفا طرقاً جديدة للتواصل مع شريكك من خلال تجارب ذات معنى',
  'landing.feature.fun.title': 'متعة تفاعلية',
  'landing.feature.fun.body':
    'بطاقات الخدش تكشف أفكاراً مشوقة تُبقي المغامرة متجددة وجذابة بحركات ديناميكية',
  'landing.feature.shared.title': 'تجربة مشتركة',
  'landing.feature.shared.body':
    'تابعا تقدمكما معاً واحتفلا بإنجازاتكما كزوجين في هذه الرحلة الجميلة',
  'landing.footer.tagline': 'نقوّي العلاقات، مغامرة بعد مغامرة',
  'landing.footer.rights': '© {{year}} غراميات. جميع الحقوق محفوظة.',

  'catalog.title': 'الخيالات',
  'catalog.subtitle':
    'تصفّح الأفكار، قول إنت نفسك تجرّب إيه، وشوفوا اتفقتوا على إيه.',
  'catalog.loading': 'جارٍ تحميل الكتالوج…',
  'fantasy.catalog.error': 'مقدرناش نحمّل الكتالوج. جرّب تاني.',

  'catalog.position': 'وضعية',

  'error.boundary.title': 'عذراً! حدث خطأ ما',
  'error.boundary.body': 'واجهنا خطأً غير متوقع. لا تقلق، ليس ذلك خطأك!',
  'error.boundary.devDetails': 'تفاصيل الخطأ (التطوير)',
  'error.boundary.errorLabel': 'الخطأ:',
  'error.boundary.stackLabel': 'تتبّع الاستدعاءات:',
  'error.boundary.tryAgain': 'حاول مرة أخرى',
  'error.boundary.goHome': 'الصفحة الرئيسية',
  'error.boundary.persists': 'إذا استمرت المشكلة، يرجى التواصل مع الدعم.',
  'game.undo.reverting': 'جارٍ التراجع...',
  'scene.storyTime.badge': 'وقت الحكاية',
  'scene.storyTime.intro': 'ابنيا المشهد معاً، تفصيلاً بعد تفصيل.',
  'scene.fantasyStory.badge': 'خيال',
  'scene.fantasyStory.intro': 'تناوبا على المشاركة، فلا توجد إجابة خاطئة.',
  'scene.notImplemented': 'هذه الآلية قادمة قريباً',
  'scene.generic.direction.maleToFemale': 'من الرجل إلى المرأة',
  'scene.generic.direction.femaleToMale': 'من المرأة إلى الرجل',
  'scene.generic.direction.both': 'أي من الشريكين',
  'scene.generic.direction.general': 'عام',
  'scene.leaf.bedroomConfessions.badge': 'اعتراف',
  'scene.leaf.bedroomConfessions.intro':
    'تناوبا، أجيبا بصدق، وتوقفا متى شئتما.',
  'scene.leaf.dirtySecrets.badge': 'أسرار',
  'scene.leaf.dirtySecrets.intro':
    'الإجابات القصيرة كافية، حافظا على جو المرح.',
  'scene.leaf.naughtyActions.badge': 'طاقة التحدي',
  'scene.leaf.naughtyActions.intro': 'اطمئنا على بعضكما؛ التخطي أفضل من الضغط.',
  'scene.leaf.rolePlay.badge': 'لعب الأدوار',
  'scene.leaf.rolePlay.intro': 'حدّدا الأجواء ووزّعا الأدوار سطراً بسطر.',
  'scene.leaf.spicyChallenge.badge': 'تحدٍّ',
  'scene.leaf.spicyChallenge.intro':
    'ارفعا الحماس فقط حين يوافق الطرفان على المستوى التالي.',
  'scene.leaf.bodyPartKiss.badge': 'دوّر',
  'scene.leaf.bodyPartKiss.intro': 'دعا الحظ يختار اللحظة، واتفقا قبل أي خطوة.',
  'scene.leaf.themedAction.badge': 'دوران موضوعي',
  'scene.leaf.themedAction.intro':
    'استخدما التلميح كفكرة مرحة وكيّفاها مع أجوائكما.',
  'scene.leaf.spinToChooseAToy.badge': 'دوران الألعاب',
  'scene.leaf.spinToChooseAToy.intro':
    'شاهدا المعاينة قبل اللعب، والفضول أولاً.',
  'scene.leaf.wouldYouRather.badge': 'ماذا تفضّل',
  'scene.leaf.wouldYouRather.intro':
    'خياران، اكشفا الإجابات بعد أن يثبّت كل منكما اختياره.',
  'scene.leaf.sensesUnlocked.badge': 'الحواس',
  'scene.leaf.sensesUnlocked.intro':
    'حدّدا الحدود أولاً، واستمتعا بمؤثر واحد في كل مرة.',
  'scene.leaf.scratchAdventure.badge': 'اخدش',
  'scene.leaf.scratchAdventure.intro': 'اكشفا برفق واستمتعا بالمفاجأة المرحة.',
  'scene.leaf.revealChallenge.badge': 'اكشف',
  'scene.leaf.revealChallenge.intro': 'مشاركة أعمق، والانسحاب مقبول دائماً.',

  'actions.message.startSession': 'بدأت اللعبة في {{time}}',
  'actions.message.complete':
    'أكمل {{player}} التحدي (+{{points}} نقطة) في {{time}}',
  'actions.message.skip': 'تخطّى {{player}} التحدي في {{time}}',
  'actions.message.revert': 'تم التراجع عن آخر إجراء في {{time}}',
  'actions.message.pauseSession': 'أُوقفت اللعبة مؤقتاً في {{time}}',
  'actions.message.resumeSession': 'استُؤنفت اللعبة في {{time}}',
  'actions.message.completeSession': 'اكتملت اللعبة في {{time}}',
  'actions.message.endSession': 'انتهت الجلسة في {{time}}',
  'actions.message.unknown': 'إجراء غير معروف في {{time}}',
  'actions.challenge': 'التحدي: {{text}}',
  'actions.duration': '{{minutes}} د {{seconds}} ث',
  'actions.points':
    '+{{count}} نقطة|+نقطة واحدة|+نقطتان|+{{count}} نقاط|+{{count}} نقطة|+{{count}} نقطة',

  'scratch.cardHeat': 'حرارة البطاقة {{level}} — {{label}}',
  'scratch.sessionMood': 'أجواء الجلسة: المستوى {{level}}',
  'scratch.sessionMood.relaxed': 'أجواء الجلسة: المستوى {{level}} (أقرب تطابق)',
  'scratch.scratchBelow': 'اخدش بالأسفل',
  'scratch.rubHint': 'افرك المنطقة البنفسجية لتكشف التحدي والوضعية والتفاصيل.',
  'scratch.reveal': 'اكشف',
  'scratch.revealAria': 'اكشف البطاقة',
  'scratch.revealed': 'تم كشف التحدي',
  'scratch.status.loadingNext': 'جارٍ تحميل التحدي التالي...',
  'scratch.status.passingTurn': 'جارٍ تمرير الدور...',
  'scratch.status.doneSolo': 'اكتمل التحدي! جارٍ تحميل البطاقة التالية...',
  'scratch.status.doneCouple': 'اكتمل التحدي! الدور على اللاعب التالي.',
  'scratch.progress': 'تم كشف {{percent}}%',
  'scratch.tip': '💡 نصيحة: اخدش مساحة أكبر لتكشف التحدي!',

  'scene.completeRound': 'إنهاء الجولة',
  'scene.roulette.badge': 'عجلة الرغبات',
  'scene.roulette.hint':
    'دوّر العجلة لتكشف رغبة الليلة، اضغط على المركز أو استخدم الزر بالأسفل.',
  'scene.roulette.wheelLabel': 'عجلة الرغبات',
  'scene.roulette.spin': 'دوّر العجلة',
  'scene.roulette.result': 'رغبتكما',
  'scene.wheel.label': 'عجلة الجوائز',
  'scene.wheel.status.spinning': 'العجلة تدور',
  'scene.wheel.status.result': 'النتيجة: {{label}}',
  'scene.wheel.status.idle': 'اضغط على الدوران لتكشف رغبتك',
  'scene.wheel.action.spin': 'دوّر العجلة',
  'scene.wheel.action.done': 'تم تدوير العجلة بالفعل',
  'scene.wheel.action.unavailable': 'الدوران غير متاح',
  'scene.wheel.hub.done': 'تم',
  'scene.wheel.hub.tap': 'اضغط',
  'scene.wheel.hub.spin': 'دوّر',

  'scene.spinning': 'جارٍ الدوران…',
  'game.player1': 'اللاعب 1',
  'game.player2': 'اللاعب 2',
  'scene.bottle.badge': 'دوّر الزجاجة',
  'scene.bottle.hint.idle': 'دوّر الزجاجة لتعرف من يبدأ أولاً!',
  'scene.bottle.hint.reveal': 'الزجاجة اختارت…',
  'scene.bottle.winner': 'الدور على {{name}}!',
  'scene.bottle.getReady': 'استعد لتحديك',
  'scene.bottle.spin': 'دوّر الزجاجة!',
  'scene.bottle.start': 'ابدأ التحدي',

  'scene.toy.badge': 'دوران الألعاب',
  'scene.toy.loading': 'جارٍ تحميل كتالوج الألعاب…',
  'scene.toy.wheelLabel': 'عجلة الألعاب',
  'scene.toy.hub': 'دوّر',
  'scene.toy.spin': 'دوّر العجلة',
  'scene.toy.result': 'النتيجة',
  'scene.toy.loadingOptions': 'جارٍ تحميل الخيارات لهذه النتيجة…',
  'scene.toy.weChose': 'اخترنا لكما: {{toy}}',
  'scene.toy.yourPick': 'اختيارك: {{toy}}',
  'scene.toy.hint.yourChoice': 'اختر أي لعبة بالأسفل تناسب مزاجك.',
  'scene.toy.hint.wildCard': 'أوسع تشكيلة، وهذا اختيار لك.',
  'scene.toy.hint.default': 'هذا اختيار من قائمتك.',
  'scene.toy.slice.surprisePick': 'اختيار مفاجئ',
  'scene.toy.slice.wildCard': 'ورقة رابحة',
  'scene.toy.slice.somethingNew': 'شيء جديد',
  'scene.toy.slice.yourChoice': 'اختيارك',
  'scene.toy.slice.mixItUp': 'اخلط الأوراق',
  'scene.toy.slice.luckyDip': 'سحب الحظ',
  'scene.toy.picker.empty': 'لا توجد ألعاب متاحة في هذه القائمة.',
  'scene.toy.picker.label': 'اختر لعبة',
  'scene.toy.picker.hint': 'اضغط على واحدة لتأكيد اختيارك',

  'scene.roulette.generic.softKiss': 'قبلة خفيفة',
  'scene.roulette.generic.deepKiss': 'قبلة عميقة',
  'scene.roulette.generic.neck': 'الرقبة',
  'scene.roulette.generic.shoulders': 'الكتفان',
  'scene.roulette.generic.slowTouch': 'لمسة بطيئة',
  'scene.roulette.generic.whisper': 'همسة',
  'scene.roulette.generic.eyeContact': 'تواصل بالعيون',
  'scene.roulette.generic.tease': 'مداعبة',
  'prompt.tag.theme': 'الموضوع: {{name}}',
  'tag.kink.anal': 'لعب من ورا',
  'tag.kink.authority': 'مين اللي بيتحكم',
  'tag.kink.begging': 'الترجّي',
  'tag.kink.blindfold': 'عصابة على العين',
  'tag.kink.bondage': 'ربط',
  'tag.kink.breeding': 'خيال الخلفة (كلام بس)',
  'tag.kink.chastity': 'لعبة الحرمان',
  'tag.kink.clothedSex': 'بهدومنا',
  'tag.kink.collaring': 'الطوق',
  'tag.kink.consentCheck': 'نطمّن على بعض',
  'tag.kink.cuckold': 'خيال الزوجة مع حد تاني',
  'tag.kink.degradation': 'إهانة باتفاق',
  'tag.kink.domSub': 'مسيطر ومطيع',
  'tag.kink.exhibition': 'حب الاستعراض',
  'tag.kink.exploration': 'استكشاف رغبات جديدة',
  'tag.kink.faceSitting': 'القعدة على الوش',
  'tag.kink.feet': 'الرجلين',
  'tag.kink.foodPlay': 'لعب بالأكل',
  'tag.kink.gags': 'السكوت الإجباري',
  'tag.kink.group': 'خيال تلاتة أو أكتر',
  'tag.kink.hairPulling': 'شد الشعر',
  'tag.kink.impact': 'ضرب خفيف',
  'tag.kink.joi': 'لمس نفسك بتوجيه',
  'tag.kink.lingerie': 'اللانجري',
  'tag.kink.marking': 'عضّ وعلامات',
  'tag.kink.mirror': 'قدام المراية',
  'tag.kink.mood': 'تجهيز الجو',
  'tag.kink.narration': 'كلام قليل الأدب',
  'tag.kink.negotiation': 'نتفق على الحدود',
  'tag.kink.orgasmControl': 'التحكم في الوصول',
  'tag.kink.pegging': 'الحزام',
  'tag.kink.petPlay': 'لعبة الأليف',
  'tag.kink.phoneSex': 'سكس على التليفون',
  'tag.kink.praise': 'حب المدح',
  'tag.kink.publicRisk': 'مخاطرة برّه',
  'tag.kink.quietSex': 'من غير صوت',
  'tag.kink.rimming': 'لحس من ورا',
  'tag.kink.roleplay': 'تقمّص أدوار',
  'tag.kink.secret': 'إثارة السر',
  'tag.kink.sensation': 'لعب بالإحساس',
  'tag.kink.stranger': 'خيال الغريب',
  'tag.kink.teasing': 'التغييظ',
  'tag.kink.temperature': 'سخن وساقع',
  'tag.kink.toys': 'ألعاب',
  'tag.kink.uniform': 'اليونيفورم واللبس',
  'tag.kink.voyeur': 'حب الفُرجة',
  'tag.kink.wax': 'لعب بالشمع',
  'tag.kink.worship': 'عبادة الجسم',
  'tag.format.action': 'تحدٍّ أو جرأة',
  'tag.format.question': 'سؤال أو صراحة',
  'tag.format.story': 'سرد قصة',
  'tag.format.wouldYouRather': 'ماذا تفضّلان؟',
  'tag.intensity.rough': 'خشن أو مكثّف',
  'tag.mechanic.chance': 'حظ وعشوائية',
  'tag.pacing.slow': 'إيقاع بطيء',
  'tag.tone.egyptianSlang': 'عامية مصرية جريئة',
  'tag.tone.explicitLanguage': 'ألفاظ صريحة',
  'tag.tone.romanticSoft': 'رومانسية وحنان',
  'tag.tone.vulnerable': 'عاطفة وانكشاف',
  'tag.position.allOral': 'كله بالفم',
  'tag.position.allSex': 'كله جنس',
  'tag.position.athletic': 'رياضي',
  'tag.position.breastAccess': 'وصول للصدر',
  'tag.position.clitAccess': 'وصول للبظر',
  'tag.position.faceToFace': 'وش لوش',
  'tag.position.frontEntry': 'دخول من قدام',
  'tag.position.manActive': 'الراجل هو اللي بيتحرك',
  'tag.position.manBridged': 'الراجل عامل كوبري',
  'tag.position.manKneeling': 'الراجل راكع',
  'tag.position.manLying': 'الراجل نايم',
  'tag.position.manOnTop': 'الراجل فوق',
  'tag.position.manSitting': 'الراجل قاعد',
  'tag.position.manSquatting': 'الراجل قرفصاء',
  'tag.position.manStanding': 'الراجل واقف',
  'tag.position.neitherOnTop': 'جنب بعض',
  'tag.position.rearEntry': 'دخول من ورا',
  'tag.position.spankingAccess': 'مساحة للصفع',
  'tag.position.twistedEntry': 'دخول بلفّة',
  'tag.position.womanActive': 'الست هي اللي بتتحرك',
  'tag.position.womanBridged': 'الست عاملة كوبري',
  'tag.position.womanKneeling': 'الست راكعة',
  'tag.position.womanLying': 'الست نايمة',
  'tag.position.womanOnTop': 'الست فوق',
  'tag.position.womanSitting': 'الست قاعدة',
  'tag.position.womanSquatting': 'الست قرفصاء',
  'tag.position.womanStanding': 'الست واقفة',
  'tag.theme.kinks': 'رغبات وفيتشات',
  'tag.theme.appreciation': 'مجاملات وتقدير',
  'tag.theme.bathroomWater': 'الحمّام أو الماء',
  'tag.theme.bedroom': 'غرفة النوم',
  'tag.theme.bodyConfidence': 'الثقة بالجسد',
  'tag.theme.bodyFocus': 'التركيز على الجسد',
  'tag.theme.communication': 'التواصل',
  'tag.theme.confession': 'اعتراف',
  'tag.theme.confidence': 'الثقة بالنفس',
  'tag.theme.consentBoundaries': 'الموافقة والحدود',
  'tag.theme.desire': 'الرغبة',
  'tag.theme.dreams': 'أحلام',
  'tag.theme.endurance': 'التحمّل',
  'tag.theme.fantasy': 'خيال',
  'tag.theme.intensity': 'الحدّة',
  'tag.theme.intimacy': 'القرب الحميم',
  'tag.theme.kiss': 'التقبيل',
  'tag.theme.massage': 'تدليك',
  'tag.theme.memory': 'ذكريات وماضٍ',
  'tag.theme.oral': 'الجنس الفموي',
  'tag.theme.orgasm': 'التركيز على الذروة',
  'tag.theme.passion': 'الشغف',
  'tag.theme.positions': 'أوضاع',
  'tag.theme.publicRisk': 'مكان عام أو مجازفة',
  'tag.theme.restraint': 'تقييد',
  'tag.theme.roleplay': 'لعب أدوار',
  'tag.theme.sensesGame': 'لعبة الحواس',
  'tag.theme.sensory': 'حسّي',
  'tag.theme.touch': 'اللمس',
  'tag.theme.toys': 'ألعاب',
  'tag.theme.trust': 'الثقة المتبادلة',
  'tag.theme.undressing': 'التعرّي',
  'tag.theme.voyeurEyeContact': 'نظرات ومشاهدة',
  'tag.theme.whisper': 'همس',

  'fantasyExplorer.loading': 'جارٍ تحميل كتالوج الخيالات…',
  'fantasyExplorer.ratingQuestion': 'ما شعورك تجاه هذه الفكرة؟',
  'fantasyExplorer.syncError': 'تعذّرت المزامنة مع الخادم.',
  'fantasyExplorer.intro.solo':
    'اختر حتى ثلاثة خيالات: ابدأ من موضوع، واستكشفه، ثم تعمّق في أحد أشكاله. بعدها قيّم مدى إعجابك بكل فكرة، وكل ذلك خاص بك.',
  'fantasyExplorer.intro.couple':
    'يختار كل منكما حتى ثلاثة خيالات بالتناوب على هذا الهاتف: أولاً {{player1}}، ثم {{player2}}. بعد ذلك سترون نقاط التشابه، ويقيّم كلٌّ منكما اختياراته.',
  'fantasyExplorer.picker.title': '{{name}}، اختر حتى {{count}} خيالات',
  'fantasyExplorer.picker.stepThemes': 'الخطوة ١ · اختر موضوعاً',
  'fantasyExplorer.picker.stepExplore': 'الخطوة ٢ · استكشف',
  'fantasyExplorer.picker.stepDig': 'الخطوة ٣ · تعمّق أكثر',
  'fantasyExplorer.picker.recommended.title': 'مقترح لكما',
  'fantasyExplorer.picker.recommended.body':
    'بداية سريعة: فكرة افتتاحية من كل موضوع من أول ثلاثة مواضيع. هو مجرد اقتراح، ويمكنك تغيير أي منه.',
  'fantasyExplorer.picker.recommended.use': 'استخدم هذه الاختيارات',
  'fantasyExplorer.picker.recommended.applied': 'أُضيف الاقتراح أدناه',
  'fantasyExplorer.picker.suggestedNote': 'اقتراح لك. عدّل كما تشاء.',
  'fantasyExplorer.picker.pickedIn': 'تم اختيار {{count}}',
  'fantasyExplorer.picker.backToThemes': 'كل المواضيع',
  'fantasyExplorer.picker.backTo': 'العودة إلى {{name}}',
  'fantasyExplorer.picker.digDeeper': 'تعمّق أكثر',
  'fantasyExplorer.picker.narrowedTo': 'محدَّد على {{name}}',
  'fantasyExplorer.picker.removePick': 'إزالة من اختياراتي',
  'fantasyExplorer.picker.yourPicks': 'اختياراتك',
  'fantasyExplorer.picker.empty':
    'لا شيء بعد. اختر موضوعاً أو استخدم الاختيارات المقترحة.',
  'fantasyExplorer.picker.remove': 'إزالة {{name}}',
  'fantasyExplorer.picker.full':
    'لديك {{count}} اختيارات. أزل واحداً لإضافة آخر.',
  'fantasyExplorer.picker.confirm': 'ثبّت اختياراتي',
  'fantasyExplorer.begin': 'ابدأ',
  'fantasyExplorer.refine.keepBroad': 'الاحتفاظ بالموضوع العام فقط',
  'fantasyExplorer.refine.cta.solo': 'قيّم اختياراتك',
  'fantasyExplorer.refine.cta.passPhone': 'مرّر الهاتف إلى الشريك ب',
  'fantasyExplorer.refine.cta.overlap': 'شاهد معاينة التشابه',
  'fantasyExplorer.handoff.prefix': 'سلّم الجهاز إلى',
  'fantasyExplorer.handoff.suffix':
    '. لا تنظر إلى اختيارات الشريك أ، فالصدق يجعلها أمتع.',
  'fantasyExplorer.handoff.ready': '{{name}} جاهز للاختيار',
  'fantasyExplorer.overlap.title': 'أفكار للحوار',
  'fantasyExplorer.overlap.hint':
    'التشابه يدعو للفضول وليس واجباً. احتفلا بالتوافق واستكشفا التشابه الخفيف برفق.',
  'fantasyExplorer.overlap.computing': 'جارٍ حساب المواضيع المشتركة…',
  'fantasyExplorer.overlap.aligned': 'تفاصيل متوافقة',
  'fantasyExplorer.overlap.noAligned': 'لا توجد تفاصيل متطابقة بعد.',
  'fantasyExplorer.overlap.soft': 'الموضوع نفسه · بلمسة مختلفة',
  'fantasyExplorer.overlap.noSoft': 'لا شيء ظاهر.',
  'fantasyExplorer.overlap.broad': '(عام)',
  'fantasyExplorer.overlap.continue': 'المتابعة إلى مرحلة الكشف',
  'fantasyExplorer.reveal.hint':
    'تناوبا في ذكر ما أثار اهتمامكما، دون مناقشة التقييمات الآن. التقييمات خاصة في الخطوة التالية.',
  'fantasyExplorer.reveal.start': 'ابدأ التقييم الشخصي ({{name}})',
  'fantasyExplorer.rate.title': '{{name}} — قيّم اختياراتك',
  'fantasyExplorer.rate.nextPartner': 'التقييم التالي لـ {{name}}',
  'fantasyExplorer.rate.finish': 'إنهاء',
  'fantasyExplorer.rate.handoff.prefix': 'سلّم الجهاز إلى',
  'fantasyExplorer.rate.handoff.suffix':
    ' — سيقيّم أفكاره فقط، ولن تراها إلا حين تقرران التحدث عنها.',
  'fantasyExplorer.rate.complete': 'إنهاء الجلسة',
  'fantasyExplorer.done.title': 'شكراً لاستكشافكما',
  'fantasyExplorer.done.body':
    'تمت مزامنة اختياراتكما وتفاعلاتكما مع هذه الجلسة، وهي وقود رائع لأفكار لعب قادمة.',
  'fantasyExplorer.done.leave': 'مغادرة إعداد اللعبة',

  'nav.menu.open': 'فتح القائمة',
  'nav.menu.close': 'إغلاق القائمة',
  'nav.secondary': 'التنقل الثانوي',
  'nav.primary': 'التنقل الرئيسي',
  'nav.more': 'المزيد',
  'nav.moreNavigation': 'المزيد من التنقل',
  'nav.help': 'المساعدة',
  'game.actions': 'إجراءات اللعبة',
  'game.promptLoading': 'جارٍ تحميل التحدي…',
  'settings.role.admin': 'مسؤول',
  'settings.role.user': 'مستخدم',

  'lock.title': 'أدخل رمز PIN',
  'lock.keypad': 'لوحة الأرقام',
  'lock.backspace': 'حذف آخر رقم',
  'lock.entered': 'تم إدخال {{count}} من {{total}} أرقام',
  'lock.wrong':
    'رمز PIN غير صحيح. لا محاولات متبقية.|رمز PIN غير صحيح. تبقّت محاولة واحدة.|رمز PIN غير صحيح. تبقّت محاولتان.|رمز PIN غير صحيح. تبقّت {{count}} محاولات.|رمز PIN غير صحيح. تبقّت {{count}} محاولة.|رمز PIN غير صحيح. تبقّت {{count}} محاولة.',
  'lock.lockedOut': 'محاولات كثيرة جدًا. جارٍ تسجيل خروجك.',

  'security.title': 'الخصوصية والأمان',
  'security.subtitle': 'أبقِ لعبتكما خاصة على هذا الجهاز',
  'security.pin.title': 'قفل التطبيق',
  'security.pin.desc': 'يطلب رمز PIN عند فتح التطبيق وبعد بقائه في الخلفية.',
  'security.pin.status.on': 'رمز PIN مفعّل',
  'security.pin.status.off': 'رمز PIN غير مفعّل',
  'security.pin.set': 'تعيين رمز PIN',
  'security.pin.change': 'تغيير رمز PIN',
  'security.pin.remove': 'إزالة رمز PIN',
  'security.pin.current': 'رمز PIN الحالي',
  'security.pin.new': 'رمز PIN الجديد (من 4 إلى 6 أرقام)',
  'security.pin.confirm': 'أعد إدخال الرمز الجديد',
  'security.pin.save': 'حفظ الرمز',
  'security.pin.removeConfirm': 'إزالة الرمز',
  'security.pin.error.format': 'استخدم من 4 إلى 6 أرقام.',
  'security.pin.error.mismatch': 'الرمزان غير متطابقين.',
  'security.pin.saved': 'تم حفظ رمز PIN',
  'security.pin.removed': 'تمت إزالة رمز PIN',
  'security.pin.unsupported': 'يتطلب قفل PIN اتصالًا آمنًا (HTTPS).',
  'security.autolock.label': 'القفل التلقائي',
  'security.autolock.desc': 'اقفل التطبيق بعد بقائه في الخلفية لمدة',
  'security.autolock.option1': 'دقيقة واحدة',
  'security.autolock.option5': '5 دقائق',
  'security.autolock.option15': '15 دقيقة',
  'security.autolock.optionNever': 'أبدًا',
  'security.discreet.title': 'الوضع الخفي',
  'security.discreet.desc':
    'يعرض الاسم «Notes» في علامة تبويب المتصفح ويُخفي الصور.',
  'security.haptics.label': 'تفعيل الاهتزاز',

  'ageGate.title': 'للبالغين فقط',
  'ageGate.body':
    'يحتوي هذا التطبيق على محتوى صريح للأزواج. يجب أن يكون عمرك 18 عامًا أو أكثر للمتابعة.',
  'ageGate.confirm': 'عمري 18 عامًا أو أكثر',
  'ageGate.leave': 'مغادرة',
  'ageGate.explicit.reveal': 'اضغط للإظهار',
  'ageGate.explicit.hint': 'قد تكون هذه الصورة صريحة.',

  'decoy.title': 'الملاحظات',
  'decoy.new': 'ملاحظة جديدة',
  'decoy.search': 'ابحث في الملاحظات',
  'decoy.back': 'كل الملاحظات',
  'decoy.placeholder': 'ابدأ الكتابة…',
  'decoy.open': 'فتح',
  'decoy.untitled': 'بلا عنوان',
  'decoy.note1.title': 'قائمة التسوق',
  'decoy.note1.body': 'حليب، بيض، خبز، قهوة، طماطم',
  'decoy.note2.title': 'خطط نهاية الأسبوع',
  'decoy.note2.body':
    'الاتصال بأمي. غسيل الملابس. نزهة طويلة إن بقي الطقس مشمسًا.',
  'decoy.note3.title': 'أفكار كتب',
  'decoy.note3.body': 'شيء عن البحر. إعادة قراءة الكتب المفضلة القديمة.',

  'account.title': 'الحساب',
  'account.subtitle': 'بريدك الإلكتروني وبياناتك وحسابك',
  'account.verify.title': 'تحقّق من بريدك الإلكتروني',
  'account.verify.body':
    'أرسلنا رابطًا إلى {{email}}. افتحه للتحقق وتأمين حسابك.',
  'account.verify.resend': 'إعادة إرسال البريد',
  'account.verify.sending': 'جارٍ الإرسال…',
  'account.verify.sent': 'تم إرسال رسالة التحقق.',
  'account.verify.success': 'تم التحقق من بريدك الإلكتروني.',
  'account.verify.verified': 'تم التحقق من البريد الإلكتروني',
  'account.verify.error': 'تعذّر إرسال البريد. حاول مرة أخرى.',
  'account.export.title': 'تصدير بياناتي',
  'account.export.desc': 'نزّل إعداداتك وألعابك وخيالاتك كملف JSON.',
  'account.export.button': 'تصدير بياناتي',
  'account.export.busy': 'جارٍ التصدير…',
  'account.export.done': 'تم تنزيل بياناتك.',
  'account.export.error': 'تعذّر تصدير بياناتك. حاول مرة أخرى.',
  'account.export.truncated':
    'تم حفظ ملف التصدير لكنه جزئي: اقتُطعت القوائم الطويلة جدًا.',
  'account.install.title': 'ثبّت التطبيق',
  'account.install.desc': 'أضف غراميات إلى شاشتك الرئيسية لفتحه كأي تطبيق آخر.',
  'account.delete.title': 'حذف حسابي',
  'account.delete.desc':
    'يزيل حسابك وبياناتك الشخصية نهائيًا. لا يمكن التراجع عن ذلك.',
  'account.delete.button': 'حذف حسابي',
  'account.delete.sheetTitle': 'حذف حسابك؟',
  'account.delete.warning':
    'سيتم حذف حسابك وبياناتك الشخصية نهائيًا. لا يمكن التراجع عن هذا الإجراء.',
  'account.delete.password': 'أكّد بكلمة المرور',
  'account.delete.confirm': 'حذف نهائيًا',
  'account.delete.busy': 'جارٍ الحذف…',
  'account.delete.wrongPassword': 'كلمة المرور غير صحيحة.',
  'account.delete.done': 'تم حذف حسابك.',
  'account.error.network': 'لا يوجد اتصال. تحقق من الشبكة وحاول مرة أخرى.',
  'account.error.generic': 'حدث خطأ ما. حاول مرة أخرى.',

  'game.round.short': 'ج{{round}}',
  'game.action.done': 'تم',
  'game.toast.done': 'تم الإنجاز',
  'game.toast.skipped': 'تم التخطي',
  'game.toast.undo': 'تراجع',
  'game.scorePair': 'النتيجة: {{name1}} {{score1}}، {{name2}} {{score2}}',
  'game.scoreSolo': 'النتيجة: {{score}}',
  'game.pauseFailed': 'تعذّر حفظ الإيقاف المؤقت. ما زالت اللعبة نشطة.',
  'game.more.title': 'قائمة اللعبة',
  'game.more.undo': 'التراجع عن الأخير',
  'game.more.history': 'السجل',
  'game.more.pause': 'إيقاف مؤقت',
  'game.more.quickHandoff': 'تسليم سريع',
  'game.more.quickHandoff.desc': 'ينتقل تلقائيًا بعد لحظة من تمرير الهاتف',
  'game.more.sound': 'الصوت',
  'game.more.haptics': 'الاهتزاز',
  'game.completed.title': 'انتهت هذه اللعبة',
  'game.end.title': 'إنهاء هذه اللعبة؟',
  'game.end.winner': 'الفوز لـ {{name}}!',
  'game.end.tie': 'تعادل',
  'game.end.solo': 'حصلت على {{score}} نقطة',
  'game.end.rounds':
    'لم تُلعب أي جولة|لُعبت جولة واحدة|لُعبت جولتان|لُعبت {{count}} جولات|لُعبت {{count}} جولة|لُعبت {{count}} جولة',
  'game.end.playAgain': 'العب مرة أخرى',
  'game.end.backHome': 'العودة إلى الرئيسية',
  'game.end.keepPlaying': 'تابع اللعب',
  'game.handoff.title': 'مرّر الهاتف إلى {{name}}',
  'game.handoff.ready': 'أنا {{name}}، لنبدأ',
  'game.handoff.hint': 'تبقى البطاقة التالية مخفية حتى تضغط.',
  'game.handoff.countdown': 'سيتابع بعد لحظة',
  'game.timer.label': 'الوقت المتبقي',
  'game.timer.start': 'ابدأ المؤقت',
  'game.timer.up': 'انتهى الوقت',
  'consent.line.skip': 'يحق لأي منكما تخطي أي بطاقة دون أي أسئلة.',
  'consent.line.safeWord': 'قل كلمة الأمان للتوقف فورًا: {{word}}',
  'consent.line.private': 'كل شيء يبقى بينكما فقط.',
  'consent.safeWord.default': 'توقف',
  'checkin.title': 'هل كل شيء على ما يرام؟',
  'checkin.body': 'الجولة {{round}}: وقفة سريعة. كيف حالكما؟',
  'checkin.keepGoing': 'تابعا اللعب',
  'checkin.dialDown': 'خففا الحرارة',
  'checkin.done': 'اكتفينا',
  'checkin.dialDown.applied': 'خُفّض مستوى الجرأة قليلًا.',
  'checkin.dialDown.floor': 'أنتما بالفعل عند ألطف مستوى اخترتماه.',
  'checkin.dialDown.failed': 'تعذّر تغيير المستوى. سنكمل كما كنا.',

  'setup.spice.fineTune': 'ضبط دقيق',

  // --- Phase 2: couple pairing and two-device play ---
  'nav.play': 'اللعب',
  'nav.partner': 'الشريك',
  'dashboard.partner.paired': 'مرتبط مع {{name}}',
  'dashboard.partner.online': '{{name}} على الإنترنت',
  'dashboard.partner.openPartner': 'افتح تبويب الشريك',
  'partner.title': 'شريكك',
  'partner.subtitle.unpaired':
    'اربطا هاتفيكما لتلعبا معًا، حتى من مكانين مختلفين.',
  'partner.subtitle.paired':
    'أنتما مرتبطان. العبا على هاتفين، أو ألقيا التحية، أو أرسلا تنبيهًا لطيفًا.',
  'partner.loading': 'جارٍ تحميل بيانات الشريك...',
  'partner.loadFailed': 'تعذّر تحميل بيانات الارتباط.',
  'partner.invite.title': 'ادعُ شريكك',
  'partner.invite.body':
    'أنشئ رمزًا وأرسله إلى شريكك. يبقى صالحًا لمدة 24 ساعة.',
  'partner.invite.create': 'إنشاء رمز دعوة',
  'partner.invite.creating': 'جارٍ الإنشاء...',
  'partner.invite.codeLabel': 'رمز الدعوة {{code}}',
  'partner.invite.copy': 'نسخ الرمز',
  'partner.invite.copyLink': 'نسخ الرابط',
  'partner.invite.copied': 'تم النسخ',
  'partner.invite.copyFailed': 'تعذّر النسخ. حدّد الرمز وانسخه يدويًا.',
  'partner.invite.share': 'مشاركة',
  'partner.invite.shareTitle': 'انضم إليّ في غراميات',
  'partner.invite.shareText': 'استخدم رمزي {{code}} للارتباط بي في غراميات.',
  'partner.invite.qrLabel': 'رمز QR لرابط الدعوة',
  'partner.invite.waiting': 'بانتظار أن يُدخل شريكك الرمز...',
  'partner.invite.expires': 'صالح لمدة 24 ساعة',
  'partner.join.title': 'لدي رمز',
  'partner.join.body': 'أدخل الرمز المكوّن من 6 أحرف الذي أرسله لك شريكك.',
  'partner.join.groupLabel': 'رمز الدعوة',
  'partner.join.digit': 'الحرف {{index}} من {{total}}',
  'partner.join.submit': 'اربط الحسابين',
  'partner.join.submitting': 'جارٍ الربط...',
  'partner.error.alreadyCoupled':
    'أنت مرتبط بالفعل. ألغِ الارتباط الحالي أولًا لتربط حسابًا آخر.',
  'partner.error.ownInvite': 'هذا رمزك أنت. أرسله إلى شريكك بدلًا من ذلك.',
  'partner.error.inviteAlreadyUsed':
    'استُخدم هذا الرمز من قبل. اطلب من شريكك رمزًا جديدًا.',
  'partner.error.inviteNotFound':
    'لم نعثر على هذا الرمز. تحقق منه وحاول مجددًا؛ ربما انتهت صلاحيته.',
  'partner.error.noActiveCouple': 'لست مرتبطًا بأحد حاليًا.',
  'partner.error.emailUnverified': 'أكّد بريدك الإلكتروني قبل الارتباط.',
  'partner.error.codeRequired': 'أدخل أحرف الرمز الستة كاملة.',
  'partner.error.wrongPassword': 'كلمة المرور غير صحيحة.',
  'partner.error.tooManyAttempts':
    'رموز خاطئة كثيرة. انتظر بضع دقائق ثم حاول مجددًا.',
  'partner.error.rateLimited': 'محاولات كثيرة. انتظر قليلًا ثم حاول مجددًا.',
  'partner.error.network': 'تعذّر الوصول إلى الخادم. تحقق من اتصالك.',
  'partner.error.unknown': 'حدث خطأ ما. حاول مرة أخرى.',
  'partner.toast.paired': 'أنتما الآن مرتبطان مع {{name}}!',
  'partner.toast.unlinked': 'لم تعد مرتبطًا بأحد.',
  'partner.card.avatar': 'صورة {{name}}',
  'partner.status.online': 'على الإنترنت الآن',
  'partner.status.offline': 'ليس على الإنترنت',
  'partner.status.lastSeen': 'آخر ظهور {{time}}',
  'partner.lastSeen.now': 'قبل لحظات',
  'partner.lastSeen.minutes': 'قبل {{count}} د',
  'partner.lastSeen.hours': 'قبل {{count}} س',
  'partner.lastSeen.days':
    'قبل {{count}} يوم|قبل يوم|قبل يومين|قبل {{count}} أيام|قبل {{count}} يومًا|قبل {{count}} يوم',
  'partner.play.now': 'العبا معًا الآن',
  'hostSetup.title': '{{name}} هو اللي بيجهّز ألعابكم',
  'hostSetup.body': 'هتدخل اللعبة أول ما تبدأ.',
  'hostSetup.sheetHint': '{{name}} هو اللي بيجهّز الألعاب ليكم الاتنين.',
  'partner.nudge.button': 'تنبيه لطيف',
  'partner.nudge.title': 'أرسل تنبيهًا إلى {{name}}',
  'partner.nudge.wave': 'ألقِ التحية',
  'partner.nudge.wave.desc': 'تحية سريعة ودودة',
  'partner.nudge.missYou': 'اشتقت إليك',
  'partner.nudge.missYou.desc': 'دعه يعرف أنك تفكر فيه',
  'partner.nudge.playNow': 'هيا نلعب',
  'partner.nudge.playNow.desc': 'ادعُه للانضمام إليك الآن',
  'partner.nudge.sent': 'أُرسل إلى {{name}}',
  'partner.nudge.wait': 'يمكنك إرسال تنبيه آخر بعد {{seconds}} ث',
  'partner.unlink.button': 'إلغاء الارتباط',
  'partner.unlink.title': 'إلغاء الارتباط مع {{name}}؟',
  'partner.unlink.body':
    'تنتهي الألعاب المشتركة لكليكما، وستحتاجان إلى رمز جديد للارتباط من جديد.',
  'partner.unlink.password': 'كلمة مرورك',
  'partner.unlink.confirm': 'إلغاء الارتباط',
  'partner.unlink.busy': 'جارٍ إلغاء الارتباط...',
  'pair.title': 'اربط حسابك بشريكك',
  'pair.subtitle': 'تحقق من الرمز أدناه ثم اضغط لربط حسابيكما.',
  'pair.noCode':
    'لا يحتوي هذا الرابط على رمز. اطلب من شريكك إرساله مجددًا أو اكتب الرمز بنفسك.',
  'pair.goPartner': 'اذهب إلى تبويب الشريك',
  'safetyNote.label': 'قبل أن تبدآ',
  'waitingRoom.title': 'لعبتكما على وشك البدء',
  'waitingRoom.summary': 'إعدادات اللعبة',
  'waitingRoom.deck': 'المجموعة',
  'waitingRoom.deckMixed': 'مزيج من كل شيء',
  'waitingRoom.heat': 'الحرارة',
  'waitingRoom.heatAny': 'أي مستوى',
  'waitingRoom.heatLevel': 'المستوى {{level}}',
  'waitingRoom.players': 'اللاعبان',
  'waitingRoom.where': 'المكان',
  'waitingRoom.waiting': 'بانتظار أن يبدأ {{name}} اللعبة...',
  'lobby.title': 'جاهزان متى شئتما',
  'lobby.players': 'اللاعبون في هذه اللعبة',
  'lobby.you': '{{name}} (أنت)',
  'lobby.here': 'متصل',
  'lobby.notHere': 'غير متصل بعد',
  'lobby.waiting': 'بانتظار {{name}}...',
  'lobby.hint':
    'يظهر زر الانضمام في الشاشة الرئيسية عند {{name}}. اضغط «ابدأ الآن» عندما تكونان جاهزين، وستفتح اللعبة وحدها على هاتف {{name}}.',
  'lobby.copyLink': 'نسخ الرابط',
  'lobby.linkCopied': 'تم نسخ الرابط',
  'lobby.nudge': 'نبّه {{name}}',
  'lobby.nudgeSent': 'أُرسل التنبيه',
  'lobby.startNow': 'ابدأ الآن',
  'lobby.starting': 'جارٍ البدء...',
  'lobby.leave': 'العودة للرئيسية',
  'twoDevice.join.label': 'شريكك بانتظارك',
  'twoDevice.join.title': 'انضم إلى لعبة {{name}}',
  'twoDevice.join.started': '{{name}} بدأ لعبة',
  'twoDevice.join.button': 'انضمام إلى اللعبة',
  'twoDevice.remoteChip': 'عبر المكالمة',
  'twoDevice.waitingFor': 'بانتظار {{name}}...',
  'twoDevice.sharedCard': 'تظهر هذه البطاقة على الهاتفين',
  'twoDevice.reactions.label': 'أرسل تفاعلًا',
  'twoDevice.reaction.send': 'إرسال {{emoji}}',
  'twoDevice.reaction.failed': 'تعذّر إرسال التفاعل.',
  'twoDevice.nudge.button': 'نبّه {{name}}',
  'twoDevice.nudge.sent': 'أُرسل التنبيه',
  'twoDevice.nudge.failed': 'تعذّر إرسال التنبيه.',
  'twoDevice.secret.title': 'بطاقة سرية لـ{{name}}',
  'twoDevice.secret.body': 'يراها {{name}} وحده. انتظر الكشف عنها.',
  'twoDevice.flash.done': '{{name}}: تم التحدي! +{{points}}',
  'twoDevice.flash.skipped': '{{name}}: تم تخطي البطاقة',
  'twoDevice.error.notYourTurn': 'ليس دورك الآن. حدّثنا اللعبة.',
  'twoDevice.error.staleCard': 'تغيّرت البطاقة. نعرض أحدثها.',
  'twoDevice.error.noCurrentCard': 'لم تكن البطاقة جاهزة بعد. نجلبها الآن.',
  'twoDevice.paused.title': 'اللعبة متوقفة مؤقتًا',
  'twoDevice.paused.body':
    'أوقف أحدكما اللعبة مؤقتًا. استأنفاها حين تكونان جاهزين.',
  'twoDevice.paused.resume': 'استئناف',
  'twoDevice.paused.home': 'العودة للرئيسية',
  'twoDevice.ended.title': 'انتهت اللعبة',
  'twoDevice.ended.note': 'تم إنهاء هذه اللعبة. هذه هي النتيجة.',
  'twoDevice.loadingCard': 'جارٍ جلب البطاقة التالية...',
  'realtime.live': 'مباشر',
  'realtime.syncing': 'مزامنة',
  'realtime.offline': 'غير متصل',
  'realtime.announce.live': 'متصل مباشرةً بشريكك',
  'realtime.announce.syncing': 'تتم المزامنة مع شريكك',
  'realtime.announce.offline': 'أنت غير متصل بالإنترنت',
  'realtime.nudge.wave': 'تحية من {{name}}',
  'realtime.nudge.missYou': 'رسالة من {{name}}: اشتقت إليك',
  'realtime.nudge.playNow': 'دعوة للعب من {{name}}',
  'realtime.nudge.inGame': '{{name}} بانتظارك',
  'realtime.nudge.join': 'انضمام',
  'realtime.nudge.noGame': 'لا توجد لعبة للانضمام إليها الآن.',
  'quickSetup.apart.pairFirst': 'اربط حسابك بشريكك أولًا',
  'quickSetup.apart.desc': 'كلٌّ على هاتفه، عبر مكالمة.',
  'quickSetup.room.label': 'هاتفان في الغرفة نفسها',
  'quickSetup.room.desc': 'يلعب كل منكما على هاتفه.',
  'quickSetup.reason.notPaired': 'اربط حسابك بشريكك لتلعبا على هاتفين.',
  'pwa.update.available': 'يتوفر إصدار جديد',
  'pwa.update.action': 'تحديث',
  'pwa.offline.banner':
    'أنت غير متصل بالإنترنت — ستتابعان لعبتكما عند عودة الاتصال',
  'pwa.offline.bannerDiscreet': 'أنت غير متصل بالإنترنت',
  'pwa.install.action': 'تثبيت التطبيق',
  'pwa.install.iosHint': 'مشاركة ← إضافة إلى الشاشة الرئيسية',

  'notFound.title': 'الصفحة غير موجودة',
  'notFound.body': 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
  'notFound.home': 'العودة إلى البداية',
  'notFound.help': 'مركز المساعدة',

  'app.route.loading': 'جارٍ التحميل...',

  'api.status.unavailable':
    'الخدمة غير متاحة مؤقتًا (صيانة). يُرجى المحاولة مرة أخرى بعد بضع دقائق.',
  'auth.error.unavailable':
    'الخدمة غير متاحة مؤقتًا. يُرجى المحاولة مرة أخرى بعد بضع دقائق.',

  'legal.nav.label': 'المعلومات القانونية',
  'legal.link.terms': 'شروط الاستخدام',
  'legal.link.privacy': 'سياسة الخصوصية',
  'legal.link.cookies': 'ملفات الارتباط والتخزين',
  'legal.link.age': 'لمن هم فوق 18 عامًا فقط',
  'auth.register.consent.and': ' و',
  'auth.register.consent.linkPrivacy': 'سياسة الخصوصية',

  'fantasy.tabs.label': 'عرض الخيالات',
  'fantasy.tabs.explore': 'استكشاف',
  'fantasy.tabs.matches': 'اللي اتفقنا عليه',
  'fantasy.answer.love': 'أيوه، نجرّبها',
  'fantasy.answer.maybe': 'يمكن، فضولي',
  'fantasy.answer.no': 'مش ليا',
  'fantasy.answer.group': 'إجابتك على {{title}}',
  'fantasy.answer.question': 'تجرّبها؟',
  'fantasy.answer.save.error': 'معرفناش نحفظ إجابتك. جرّب تاني.',
  'fantasy.answer.save.rateLimited': 'ضغطات كتير. استنى شوية وجرّب تاني.',
  'fantasy.explore.progress': 'جاوبت على {{answered}} من {{total}}',
  'fantasy.explore.privacy':
    'إجاباتك محفوظة في حسابك. شريكك عمره ما هيشوف "مش ليا" إلا لو إنت اخترت تشاركها.',
  'fantasy.answers.loadError': 'معرفناش نحمّل إجاباتك.',
  'fantasy.matches.pairFirst.title': 'التطابق محتاج اتنين',
  'fantasy.matches.pairFirst.body':
    'اربط حسابك بشريكك عشان تشوفوا إنتو الاتنين نفسكم تجرّبوا إيه.',
  'fantasy.matches.pairFirst.cta': 'روح لصفحة الشريك',
  'fantasy.matches.loading': 'بنحمّل اللي اتفقتوا عليه…',
  'fantasy.matches.loadError': 'معرفناش نحمّل اللي اتفقتوا عليه.',
  'fantasy.matches.progress.mine': 'جاوبت على {{answered}} من {{total}}',
  'fantasy.matches.progress.partner':
    '{{name}} جاوب على {{answered}} من {{total}}',
  'fantasy.matches.both.title': 'إنتو الاتنين نفسكم تجرّبوه',
  'fantasy.matches.curious.title': 'واحد فيكم فضولي',
  'fantasy.matches.you': 'إنت: {{answer}}',
  'fantasy.matches.partner': '{{name}}: {{answer}}',
  'fantasy.matches.empty.title': 'لسه مفيش تطابق',
  'fantasy.matches.empty.body':
    'التطابق بيظهر لما إنتو الاتنين تقولوا "نفسي أجرّبها" أو "يمكن، فضولي" على نفس الخيال.',
  'fantasy.matches.empty.cta': 'استكشف الخيالات',
  'fantasy.matches.privacy':
    'اللي بيتشارك هو التطابق بس. "مش ليا" بيفضل سر، وكمان أي خيال واحد بس فيكم جاوب عليه.',
  'fantasy.matches.others.title': 'إجابات {{name}} التانية',
  'fantasy.matches.others.body': '{{name}} اختار يشارك كل إجاباته معاك.',
  'fantasy.share.label': 'خلّي {{name}} يشوف كل إجاباتي، حتى "مش ليا"',
  'fantasy.share.help':
    'مقفولة في الأول. وهي شغالة، {{name}} هيشوف كل إجابة بتجاوبها. التطابق بيظهر لكم الاتنين دايمًا.',
  'fantasy.share.error': 'معرفناش نحفظ الإعداد ده. جرّب تاني.',
  'fantasyExplorer.done.matches.title': 'اللي اتفقتوا عليه في اللعبة دي',
  'fantasyExplorer.done.matches.empty':
    'مفيش تطابق المرة دي. إجاباتك اتحفظت في الخيالات.',
  'fantasyExplorer.done.seeAll': 'شوف كل اللي اتفقنا عليه',
  'exploration.picker.title': '{{name}}، اختار لحد {{count}} خيالات',
  'exploration.picker.secret': 'اختياراتك سر لحد ما إنتو الاتنين تقفلوها.',
  'exploration.picker.pickedIn': 'اتختار {{count}}',
  'exploration.picker.variationOf': 'نسخة تانية من {{name}}',
  'exploration.picker.yourPicks': 'اختياراتك',
  'exploration.picker.counter': 'اخترت {{selected}} من {{total}}',
  'exploration.picker.empty': 'دوس على كارت عشان تختاره. لحد {{count}}.',
  'exploration.picker.full':
    'ده آخر {{count}} تقدر تختارهم. شيل واحد عشان تختار غيره.',
  'exploration.picker.remove': 'شيل {{name}}',
  'exploration.picker.lock': 'اقفل اختياراتي',
  'exploration.picker.locking': 'بنقفل…',
  'exploration.wait.picks': 'في انتظار اختيارات {{name}}…',
  'exploration.wait.picksCount': 'اللي اتختار لحد دلوقتي: {{count}}',
  'exploration.wait.picksHint':
    'اختياراتك اتقفلت وهي سر. هتشوف اختيارات {{name}} أول ما تتقفل هي كمان.',
  'exploration.wait.yourPicks': 'اختياراتك المقفولة',
  'exploration.wait.answers': 'في انتظار إجابات {{name}}…',
  'exploration.wait.answersHint':
    'إجاباتك اتبعتت. النتيجة هتظهر هنا أول ما إجابات {{name}} تخلص.',
  'exploration.respond.loading': 'بنجيب الاختيارات…',
  'exploration.respond.intro':
    'دي اختيارات {{name}}. قول إحساسك تجاه كل واحدة. مفيش إجابة غلط.',
  'exploration.respond.pickedBy': 'من اختيارات {{name}}',
  'exploration.respond.progress': '{{current}} من {{total}}',
  'exploration.respond.bothBadge': 'إنتو الاتنين اخترتوها!',
  'exploration.respond.bothNote':
    'بتتحسب أيوه منكم الاتنين. مفيش حاجة تجاوب عليها.',
  'exploration.respond.back': 'رجوع',
  'exploration.respond.next': 'التالي',
  'exploration.respond.remaining':
    'مفيش حاجة باقية|باقي واحدة تجاوب عليها|باقي اتنين تجاوب عليهم|باقي {{count}} تجاوب عليهم|باقي {{count}} تجاوب عليهم|باقي {{count}} تجاوب عليهم',
  'exploration.respond.send': 'ابعت إجاباتي',
  'exploration.respond.sending': 'بنبعت…',
  'exploration.respond.nothing':
    'اخترتوا نفس الخيالات، فمفيش حاجة تجاوب عليها.',
  'exploration.results.title': 'اللي لقيتوه سوا',
  'exploration.results.intro':
    'الإجابات معروضة بلطف. وكلمة "لأ" بتفضل هادية من غير أي ضغط.',
  'exploration.results.both': 'إنتو الاتنين نفسكم تجرّبوه',
  'exploration.results.maybe': 'يمكن، نتكلم فيها',
  'exploration.results.fantasy': 'خليها خيال',
  'exploration.results.no.partner': 'مش لـ {{name}}',
  'exploration.results.no.you': 'مش ليك',
  'exploration.results.no.note': 'عادي جدًا. مفيش حاجة تتابعوها.',
  'exploration.results.pickedByYou': 'إنت اخترتها',
  'exploration.results.pickedByName': 'من اختيارات {{name}}',
  'exploration.results.bothPicked': 'إنتو الاتنين اخترتوها',
  'exploration.results.loading': 'بنجمّع النتيجة…',
  'exploration.results.error': 'معرفناش نحمّل النتيجة.',
  'exploration.results.empty': 'مفيش حاجة تتعرض المرة دي.',
  'exploration.results.seeAll': 'شوف كل اللي اتفقنا عليه',
  'exploration.results.playAgain': 'العب تاني',
  'exploration.results.askHost': 'اطلب من {{name}} يبدأ جولة تانية.',
  'exploration.results.backHome': 'رجوع للرئيسية',
  'exploration.error.notYourSeat': 'ده بتاع شريكك.',
  'exploration.error.tooManyPicks': 'ده أكتر من العدد المسموح.',
  'exploration.error.picksRequired': 'اختار خيال واحد على الأقل الأول.',
  'exploration.error.unknownFantasy':
    'واحد من الخيالات دي مبقاش متاح. اختار تاني.',
  'exploration.error.picksLocked': 'اختياراتك اتقفلت قبل كده.',
  'exploration.error.notPartnerPick': 'دي مش من اختيارات شريكك.',
  'exploration.error.responsesIncomplete': 'جاوب على كل الكروت قبل ما تبعت.',
  'exploration.error.responsesLocked': 'إجاباتك اتبعتت قبل كده.',
  'exploration.error.notResponding':
    'الإجابات بتفتح أول ما تقفلوا اختياراتكم الاتنين.',
  'exploration.error.twoDevicesOnly':
    'استكشاف الخيالات محتاج موبايلين مربوطين.',
  'exploration.error.conflict': 'اللعبة اتغيرت دلوقتي. بص تاني وجرّب.',
  'exploration.error.sync': 'معرفناش نحفظ. اتأكد من النت وجرّب تاني.',
  'exploration.error.unavailable': 'استكشاف الخيالات مش متاح دلوقتي.',
  'exploration.tile.title': 'استكشاف الخيالات',
  'exploration.tile.body':
    'كل واحد فيكم بيختار لحد 5 خيالات في السر. وبعدين بتجاوبوا على اختيارات بعض بلطف.',
  'exploration.tile.start': 'ابدأ الاستكشاف',
  'exploration.tile.starting': 'بنبدأ…',
  'exploration.tile.guest': 'اطلب من {{name}} يبدأ',
  'exploration.tile.guestBody':
    'اللي دعاك هو اللي بيبدأ، وبتفتح لوحدها على موبايلك.',
  'exploration.tile.pair': 'اربط حسابك بشريكك عشان تستكشفوا سوا',
  'exploration.tile.pairCta': 'روح لصفحة الشريك',
  'exploration.partner.button': 'ابدأ استكشاف الخيالات',
  'fantasy.answer.fantasy': 'خيال بس',
  'fantasy.matches.fantasy.title': 'خليها خيال',
  'realtime.fantasyMatch.new': 'تطابق جديد مع {{name}}!',
  'realtime.fantasyMatch.view': 'شوف',
  'guest.cta.play': 'العب كضيف',
  'guest.start.title': 'العب دلوقتي من غير حساب',
  'guest.start.subtitle': 'اسمك وإنت مين بس. ببلاش، وتقدر تضيف إيميل بعدين.',
  'guest.start.name': 'اسمك',
  'guest.start.namePlaceholder': 'شريكك هيناديك بإيه؟',
  'guest.start.consent.prefix':
    'لما تكمّل إنت بتأكد إن عمرك 18 سنة أو أكتر وبتوافق على',
  'guest.start.consent.suffix': '.',
  'guest.start.submit': 'ابدأ اللعب',
  'guest.start.submit.loading': 'جارٍ البدء…',
  'guest.start.note':
    'ملفك كضيف بيفضل على الموبايل ده. ضيف إيميل بعدين عشان تحافظ عليه.',
  'guest.start.haveAccount': 'عندك حساب؟ سجّل دخول',
  'guest.profile.noEmail': 'ملف ضيف (من غير إيميل)',
  'guest.card.title': 'إنت بتلعب كضيف',
  'guest.card.body':
    'ألعابك وإجاباتك محفوظة في ملف الضيف ده. لو سجّلت خروج أو مسحت بيانات المتصفح مش هتقدر ترجعها. احفظ حسابك عشان تحافظ عليها.',
  'guest.save.title': 'احفظ حسابك',
  'guest.save.intro':
    'ضيف إيميل وكلمة سر. وكل ألعابك وشريكك وإجاباتك بتفضل زي ما هي.',
  'guest.save.passwordHint':
    '10 حروف على الأقل، فيها حروف كبيرة وصغيرة ورقم ورمز.',
  'guest.save.submit': 'احفظ حسابي',
  'guest.save.busy': 'جارٍ الحفظ…',
  'guest.save.done': 'اتحفظ حسابك. شوف إيميلك عشان تأكّده.',
  'guest.signOut.title': 'تسجّل خروج من ملف الضيف؟',
  'guest.signOut.body':
    'لو سجّلت خروج، ملف الضيف ده مش هينفع يتفتح تاني. تحفظ حسابك الأول؟',
  'guest.signOut.confirm': 'سجّل خروج برضه',
  'guest.signOut.busy': 'جارٍ تسجيل الخروج…',
  'account.delete.guest.warning':
    'ملف الضيف وألعابك وإجاباتك هيتمسحوا نهائيًا. مفيش كلمة سر تكتبها.',
  'account.delete.guest.confirm': 'فاهم إن مفيش رجوع في ده',
  'security.pin.guestWarning':
    'خمس محاولات غلط للـ PIN بتسجّل خروجك. وملف الضيف مش بيتفتح تاني بعد كده، فاحفظ حسابك الأول.',
  'pair.welcome.title': 'شريكك بعتلك دعوة',
  'pair.welcome.body':
    'العب كضيف بالاسم بس، أو سجّل دخول. وبعدها بتتربطوا بضغطة واحدة.',
  'landing.cta.createAccount': 'اعمل حساب',
  'landing.free.note': 'ببلاش للكل. من غير حساب ومن غير كارت. اسمك بس.',
  'partner.error.guestEmailUnverified':
    'الربط محتاج حساب محفوظ على السيرفر ده. اضغط احفظ حسابي من الإعدادات وجرّب تاني.',
};

export default ar;
